import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const COLLECTION_HANDLE = 'build-a-happy-box';
const MAIN_PRODUCT_TYPE = 'Box';
const ADDON_PRODUCT_TYPE = 'Gift';
const CARD_PRODUCT_TYPE = 'Card';

const actions = {
  async initialize(context){
    let pathname = location.pathname;
    if(pathname.includes("/products/")){
      await getSingleProduct(context, pathname);
    }
    await getCollectionProducts(context,'/collections/ready-to-ship-products');

    async function getSingleProduct(context,handle){
      axios.get(`${handle}.json`)
      .then(response => response.data)
      .then((data) => {
        context.commit('setSelectedProduct', data.product);
      })
    }
    async function getCollectionProducts(context, pathname){
      let collectionProducts = await axios.get(`${STORE_URL}${pathname}/products.json?limit=250`);
      collectionProducts = collectionProducts.data.products;
      let totalProductList = await axios.get('https://api.happyboxstore.com/api/bundle/collection/311180099749');
      totalProductList = totalProductList.data;
      totalProductList = collectionProducts.map((item, i) => Object.assign({}, item, totalProductList.find(x => x.id == item.id)));
      totalProductList = totalProductList.filter((product) => {
        product.variants = product.variants.filter(x => parseFloat(x.price) > 0 && (x.inventory_quantity > 0 || x.inventory_policy == "continue")).map(variant =>{
          variant.available = variant.inventory_quantity > 0 || variant.inventory_policy == "continue";
          variant.sku = variant.sku ? variant.sku : "";
          variant.featured_image = product.images.find(x => x.id == variant.image_id);
          return variant
        });
        product.tags = product.tags.split(", ")

        return product.variants.length > 0;
      });
      context.commit('setCollectionProducts', totalProductList);
      getOccasions(totalProductList);
      const params = new URLSearchParams(window.location.search);
      for (const [key, value] of params){
        if(key == "occasion")
          context.commit('setSelectedOccasion',value);
      }
      context.commit('setIsLoading', false);
    }
    function getOccasions(addonProductList){
      var tags = [...new Set(addonProductList.flatMap(x => x.tags.filter(y => y.includes("Filter_") )))];
      if(tags.length > 0){
        tags = tags.map((x) =>{
          const currentArray = x.replace("Filter_","").split("_");
          if (currentArray.length > 1){
            var currentObject = { category: currentArray[0], title: currentArray[1], tag: x };
            return currentObject;
          }
        })
        var sortedFilters = [];
        sortedFilters = [...tags.reduce((hash, {category,title,tag}) => {
          const current = hash.get(category) || { category, filters: [] };
          current.filters.push({ title, tag });
          return hash.set(category, current);
        }, new Map).values()];

        let occasions = sortedFilters.find(x => x.category == "Occasion");
        if(occasions){
          occasions.filters.unshift({title: "View All", tag: "Filter_Occasion_View All"});
          occasions.filters = occasions.filters.filter(x => !x.title.includes("Faves"))
          context.commit('setOccasions', occasions.filters);
        }
      }
    }
  },
  getProducts(context) {
    axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
    .then(response => response.data)
    .then((data) => {
      // Figure out how many pages of data we have to pull
      const numOfPages = Math.ceil(data.collection.products_count / 250);
      fetchProducts(numOfPages, []);
    })
    .catch((err) => {
      console.log('***Error Fetching NumOfProducts***');
    });

    function fetchProducts(pageNum, productList) {
      // Recursive function that gets the full list of products
      if (pageNum != 0) {
        // axios.get(`${STORE_URL}/products.json?limit=250&page=${pageNum}`) - Will Get all Products but you cant sort them
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${pageNum}`)
          .then(response => response.data)
          .then((data) => {
            const updatedProductList = [...data.products, ...productList];
            fetchProducts(pageNum - 1, updatedProductList);
          })
          .catch((err) => {
            console.log('***Error Fetching Products***');
          });
      } else {
        sortFetchedProducts(productList);
      }
    }
    function sortFetchedProducts(totalProductList) {
      axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
      .then(response => response.data)
      .then((data) => {
        totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
  
        const cardProductList = totalProductList.filter(product => (product.product_type == CARD_PRODUCT_TYPE && product.variants[0].inventory_quantity > 0));
        context.commit('setCardProducts', cardProductList);
      })
      .catch((err) => {
        console.log(err);
        console.log('***Error Fetching NumOfProducts***');
      });
    }
  },
};

export default actions;
